import composableIcons from './composableIcons';

export default {
    ...composableIcons,
};
